import {SearchDisplayContext, SearchResultType} from 'common/report/util/search/types';
import {MixpanelUserItem} from 'common/widgets/user-list/types';

export interface RowEntity {
  rowType: SearchResultType | string;
  dashboard?: string;
  displayContext?: SearchDisplayContext;
  disableUserSidebar: boolean;
  name: string;
  description: string;
  created: string;
  lastModified: string;
  lastModifiedSort?: number;
  lastModifiedDisplay: string;
  link?: string;
  report: string;
  presenceViews?: MixpanelUserItem[];
  popularityScore?: number;
  finalScore?: number;
  uniqueCount?: number;
  user: string; // this is user NAME
  userId: number;
  userEmail: string;
  value: any;
}

export enum TableField {
  Count = `count`,
  LastModified = `lastModified`,
  Name = `name`,
  User = `user`,
}
